import React, { useState } from 'react'
import api from '../../../../context/apiContext'
import WSelectFieldMulti from '../../../../components/WSelectFieldMulti'
import { showResponseError, showResponseSuccess } from '../../../../helper'
import I18n from '../../../../components/I18n'
import WCustomModal from '../../../../components/WModal/V3'
import WTextFieldV2 from '../../../../components/WTextField/V2'

const ModalAddUser = props => {
  const {
    title,
    handleCloseModal,
    environments,
    roles,
    openModal
  } = props

  const [email, setEmail] = useState('')
  const [selectedRoles, setSelectedRoles] = useState([])
  const [selectedEnvironments, setSelectedEnvironments] = useState([])

  const handleAddUser = () => {
    const data ={
      email,
      roles: selectedRoles?.map(i => ({ id: i.value })),
      environments: selectedEnvironments.map(i => ({ id: i.value }))
    }

    api({
      method: 'POST',
      url: 'users/by-email',
      data
    })
      .then(({ data }) => {
        showResponseSuccess(data?.message ?? 'Admin.USERS.ADD.SUCCESS')
        const isGetUsers = true
        handleCloseModal(isGetUsers)
      })
      .catch(error => showResponseError(error))
  }

  return (
    <WCustomModal
      buttonLabel={'Confirm'}
      title={title}
      open={openModal}
      handleClose={handleCloseModal}
      buttonOnConfirm={handleAddUser}
      icon={'check_circle'}
      element={
        <div className='flex flex-col justify-center w-96 h-96'>
          <div className='flex flex-col gap-y-10'>
            <div className='w-full'>
              <WTextFieldV2
                label={'email'}
                required
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
                variant='standard'
              />
            </div>
            <div className='w-full'>
              <WSelectFieldMulti
                label='Role'
                required
                value={selectedRoles}
                onChange={ev => setSelectedRoles(ev)}
                options={roles}
                errorText={!selectedRoles?.length ? <I18n path='Global.REQUIRED_FIELD'/> : ''}
                className='w-full'
              />
            </div>
            <div className='w-full'>
              <WSelectFieldMulti
                label={<><I18n path='Admin.USERS.ENVIRONMENTS'/></>}
                placeholder=''
                options={environments}
                value={selectedEnvironments}
                onChange={(ev) => setSelectedEnvironments(ev)}
                className='w-full'
              />
            </div>
          </div>
        </div>
      }
    />
  )
}

export default ModalAddUser